'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError from "./com.raquo.airstream.core.-Airstream-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
class $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError extends $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError.$c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(error) {
    super();
    this.rv = null;
    this.rv = error;
    $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ("ObserverError: " + $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().kT(error)), null, true, true);
  }
  I() {
    return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
  }
  m() {
    return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
  }
  f(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError)) {
      var x = this.rv;
      var x$2 = x$0.rv;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  }
  n() {
    return 1;
  }
  o() {
    return "ObserverError";
  }
  g(n) {
    if ((n === 0)) {
      return this.rv;
    }
    throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  b() {
    return ("ObserverError: " + this.rv);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError as $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cN)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverError as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverError };
var $d_Lcom_raquo_airstream_core_AirstreamError$ObserverError = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$ObserverError, "com.raquo.airstream.core.AirstreamError$ObserverError", ({
  cN: 1,
  bl: 1,
  H: 1,
  a: 1,
  b: 1,
  c: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$ObserverError as $d_Lcom_raquo_airstream_core_AirstreamError$ObserverError };
